<template>

  <modal id="registro-anterior" titulo="Referência" :loading="loading">

    <card>

      <div class="row gutters-xs">

        <div class="col">
          <!-- O rótulo muda porque a exigência muda: a unidade da matrícula-mãe pode não ter ficha
               de destino aberta, e dizer "Vinculo" seco ali fazia o conferente procurar uma
               matrícula que o teor não nomeia. Ver `getErrosFormReferenciaImovel`. -->
          <label>Vinculo <small class="text-muted" v-if="ehUnidade">(opcional)</small></label>
          <buscar-fichas livro="MATRICULA" status="ABERTA"
                         :valorInicialIndividual="form.referenciaDetalhes || matriculaMae" ref="buscarFichas" @selecionar="selecionarFichas"
                         :multiplos="false" :multiple="false" />
        </div>

        <div class="col-12 text-danger small" v-if="validation.referenciaId">{{validation.referenciaId}}</div>

        <div class="w-100"></div>

        <v-input :error="validation.tipo" class="col" v-model="form.tipo" :options="options.tipos"
                 type="select" label="Tipo" />

        <v-input :error="validation.ato" type="number" label="Ato" v-model.number="form.ato" class="col-4" />

        <div class="w-100"></div>

        <v-input class="col" :error="validation.descricao" v-model="form.descricao" type="text" label="Descrição" />

      </div>

      <!-- Os campos da UNIDADE, nos dois tipos que descrevem uma: TRANSMISSAO (a que saiu da ficha)
           e UNIDADE_DESCRITA (a que a ficha descreve e que continua nela). Na menção comum e na
           restrição não há lote nem área a editar, e mostrar cinco campos vazios ali seria pedir o
           preenchimento do que não existe.

           Aparecem depois da descrição, e não no lugar dela, porque a frase continua sendo o que as
           telas antigas exibem — inclusive a linha gravada antes de 06/09/2026, que só tem ela. -->
      <div class="row gutters-xs mt-2" v-if="ehUnidade">

        <div class="col-12">
          <hr class="my-1">
          <small class="text-muted">
            Unidade da matrícula-mãe. O que se edita aqui é o que a aba "Unidades" da ficha mostra;
            a descrição acima segue sendo o texto do card "Referências" da ficha.
            <template v-if="ehUnidadeSemMovimento">
              Este tipo diz que a unidade continua nesta matrícula: nenhum ato a moveu e nenhuma
              outra ficha a recebeu. Por isso ela não tem matrícula de destino nem vínculo —
              havendo destino, o tipo é "Transmissão".
            </template>
            <template v-else>
              O vínculo só se preenche quando a unidade já tem matrícula própria aberta neste
              acervo.
            </template>
          </small>
        </div>

        <v-input class="col-5" v-model="form.designacao" type="text" label="Designação"
                 placeholder="Lote 7, quadra 11" />
        <v-input class="col" v-model="form.proprietarios" type="text" label="Proprietário(s)"
                 placeholder="separados por vírgula" />

        <div class="w-100"></div>

        <v-input class="col-3" v-model="form.area" type="text" label="Área" placeholder="324m²" />
        <v-input class="col-3" v-model.number="form.fracao" type="number" label="Fração (%)" />
        <!-- Sem destino na unidade sem movimento, e não é zelo de tela: destino preenchido é o que
             define que a unidade SAIU (ver o comentário de `matricula_destino` em
             `ReferenciaImovel`). Oferecer o campo aqui deixaria a linha afirmar, ao mesmo tempo,
             que a unidade continua na ficha e que outra matrícula a recebeu. -->
        <v-input class="col-3" v-model="form.matriculaDestino" type="text"
                 label="Matrícula de destino" v-if="!ehUnidadeSemMovimento" />

      </div>

    </card>


    <div class="modal-footer">
      <button type="button" @click.prevent="close()" class="btn btn-secondary">Cancelar</button>
      <button type="button" @click.prevent="save()" class="btn btn-primary">Salvar</button>
    </div>

  </modal>

</template>
<script>

  import FrontBusiness from "@/business/FrontBusiness";
  import IndicadorRealBusiness from '@/business/indicadores/IndicadorRealBusiness';
  import Card from "@/components/Layout/components/Card.vue";
  import Modal from "@/components/Modal";
  import Utils from "@/commons/Utils";

  export default {
    name: 'ReferenciaImovelForm',

    components: {
      Card,
      Modal
    },

    props: {
      registro: Object,
      ficha: Object,
      matriculaMae: Object
    },

    modal: {
      width: 700
    },

    data() {
      return {
        titulo: 'Registro Anterior',
        loading: false,
        validation: {},
        fichas: [],
        form: this.registro || {},
        options: {
          tipos: IndicadorRealBusiness.getTiposReferencia()
        }
      }
    },

    computed: {
      /**
       * Esta referência é uma unidade da matrícula-mãe?
       *
       * O tipo é a régua, e não a presença dos campos: a linha gravada antes de 06/09/2026 tem
       * TRANSMISSAO e nenhuma coluna preenchida — é justamente ela que o conferente abre para
       * preencher o que faltava, e esconder o bloco dela deixaria o campo inalcançável.
       *
       * São DOIS os tipos, e a lista mora em `IndicadorRealBusiness`: a unidade que saiu da ficha e
       * a que a ficha descreve e continua tendo. As duas têm designação, dono, área e fração.
       */
      ehUnidade() {
        return IndicadorRealBusiness.eReferenciaDeUnidade(this.form.tipo);
      },
      /** A unidade de ESTOQUE: descrita na ficha, sem ato que a tenha movido e sem destino. */
      ehUnidadeSemMovimento() {
        return this.form.tipo === 'UNIDADE_DESCRITA';
      }
    },

    methods: {

      close() {
        FrontBusiness.closeModal();
      },

      save() {
        let form = Utils.clone(this.form);
        const validation = IndicadorRealBusiness.getErrosFormReferenciaImovel(this.form) || {};
        if(Object.keys(validation).length){
          this.showErros(validation);
        }else{
          FrontBusiness.closeModal(this.normalizarUnidade(form));
        }
      },

      /**
       * Os cinco campos da unidade saem daqui no formato que `ReferenciaImovelDTO` espera.
       *
       * As duas conversões existem por causa do que a gravação faz com o valor:
       * `IndicadorRealService.atualizarReferenciasImovel` é DELETE total seguido de INSERT, então o
       * que sai deste formulário é o que a linha PASSA A SER — não há merge com o que estava no
       * banco, e o que sair vazio fica vazio.
       *
       * O campo em branco vira nulo: tanto o input de texto quanto o numérico devolvem cadeia vazia
       * quando o conferente apaga o que havia, e gravar cadeia vazia onde a coluna aceita nulo faria
       * "o teor não declarou" e "foi informado como vazio" ficarem indistinguíveis para quem lê a
       * unidade — a aba "Unidades" cai no trecho correspondente da frase justamente quando o campo
       * está nulo.
       *
       * A referência que não é unidade solta os cinco: o bloco aparece só em TRANSMISSAO, e valor
       * que o conferente não vê nem consegue apagar não pode voltar ao banco. Campo invisível
       * viajando calado é exatamente o defeito que originou este conserto.
       */
      normalizarUnidade(form) {
        const texto = (valor) => {
          const limpo = (valor === null || valor === undefined) ? '' : String(valor).trim();
          return limpo === '' ? null : limpo;
        };

        if (!this.ehUnidade) {
          form.designacao = null;
          form.proprietarios = null;
          form.area = null;
          form.fracao = null;
          form.matriculaDestino = null;
          return form;
        }

        form.designacao = texto(form.designacao);
        form.proprietarios = texto(form.proprietarios);
        form.area = texto(form.area);
        // A unidade sem movimento solta o destino pelo mesmo motivo que a referência que não é
        // unidade solta os cinco: o campo não aparece para ela, e valor que o conferente não vê nem
        // consegue apagar não pode voltar ao banco. Aqui o caso concreto é a troca de tipo — a
        // linha que era transmissão e passa a ser estoque levaria junto o número da matrícula que a
        // recebeu, e a linha diria as duas coisas ao mesmo tempo.
        form.matriculaDestino = this.ehUnidadeSemMovimento ? null : texto(form.matriculaDestino);

        const fracao = texto(form.fracao);
        form.fracao = (fracao === null || Number.isNaN(Number(fracao))) ? null : Number(fracao);

        return form;
      },

      showErros(validation) {
        this.$set(this, 'validation', validation);
      },

      /****************/
      selecionarFichas(ficha, add, campoValidado, msg) {
        this.form.referenciaDetalhes = ficha[0];
        this.form.referenciaId = ficha[0]?.id;
      },

    }
  }

</script>
<style lang="scss">

  #registro-anterior {

    .modal-dialog {
      $size: 1000px;
      width: 99%;
      max-width: $size;

      .modal-body {
        background: var(--alt-bg-color);
        max-height: calc(100vh - 180px);
        overflow: auto;
        border-top: 5px solid var(--alt-bg-color);
      }

      .busca-ficha {
        margin-top: 24px;
      }

    }

    /*select.form-control:not([size]):not([multiple]){*/
    /*height: 36px;*/
    /*}*/

  }


</style>
